import Icon from '../components/Icon.vue'

Icon.register({
  'calendar-week': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V192H0V464zM64 272C64 263.2 71.2 256 80 256H368C376.8 256 384 263.2 384 272V336C384 344.8 376.8 352 368 352H80C71.2 352 64 344.8 64 336V272zM400 64H352V16C352 7.2 344.8 0 336 0H304C295.2 0 288 7.2 288 16V64H160V16C160 7.2 152.8 0 144 0H112C103.2 0 96 7.2 96 16V64H48C21.5 64 0 85.5 0 112V160H448V112C448 85.5 426.5 64 400 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calendar-week.js
// module id = J0z0
// module chunks = 144